import type { ComponentProps } from "react";
import { Card } from "@ptsd/uikit";
import { Spinner } from "tamagui";

type LoadingScreenProps = ComponentProps<typeof Card>;

export const LoadingScreen: React.FC<LoadingScreenProps> = (props) => {
  return (
    <Card
      alignItems="center"
      justifyContent="center"
      variant="borderless"
      {...props}
    >
      <Spinner color={"$lightgreen-500"} />
    </Card>
  );
};
